import { SettingsSectionDefinition } from "./SectionTypes";
import { IdentitySectionPanel } from "./IdentitySection";
import { ThemeSectionPanel } from "./ThemeSection";
import { MemberCategoriesPanel } from "./MemberCategoriesSection";
import { FacilitiesPanel } from "./FacilitiesSection";
import { FacilitySchedulesSectionPanel } from "./FacilitySchedulesSection";
import { FacilityTypesPanel } from "./FacilityTypesSection";
import { PosItemTypesPanel } from "./PosItemTypesSection";
import { JoiningFeeSectionPanel } from "./JoiningFeeSection";
import { FormsSectionPanel } from "./FormsSection";
import { SignupSectionPanel } from "./SignupSection";
import { CancellationSectionPanel } from "./CancellationSection";
import { DirectDebitNoticeSectionPanel } from "./DirectDebitNoticeSection";
import { BannersSectionPanel } from "./BannersSection";
import { CheckinSectionPanel } from "./CheckinSection";
import { BillingSectionPanel } from "./BillingSection";
import { BookingPricingSectionPanel } from "./BookingPricingSection";
import { ContactSectionPanel } from "./ContactSection";
import { MembershipCardSectionPanel } from "./MembershipCardSection";
import { ClientMetadataPanel } from "./ClientMetadataSection";

// Re-exported here so existing imports of SectionPanelProps from
// "./SectionContract" keep working — the canonical home is SectionTypes.
export type { SectionPanelProps, SettingsSectionDefinition } from "./SectionTypes";

// Order is significant: it's the order the nav renders in.
export const SETTINGS_SECTIONS: ReadonlyArray<SettingsSectionDefinition> = [
    { key: 'identity', label: 'Identity', Panel: IdentitySectionPanel },
    { key: 'general', label: 'General' },
    { key: 'branding', label: 'Branding', Panel: ThemeSectionPanel },
    { key: 'contact', label: 'Contact', Panel: ContactSectionPanel },
    { key: 'locale', label: 'Locale' },
    { key: 'tax', label: 'Tax' },
    { key: 'billing', label: 'Billing', Panel: BillingSectionPanel },
    { key: 'bookingPricing', label: 'Booking Pricing', Panel: BookingPricingSectionPanel },
    { key: 'hours', label: 'Opening Hours' },
    { key: 'joiningFee', label: 'Joining Fee', Panel: JoiningFeeSectionPanel },
    { key: 'forms', label: 'Forms', Panel: FormsSectionPanel },
    { key: 'signup', label: 'Signup', Panel: SignupSectionPanel },
    { key: 'cancellation', label: 'Cancellation', Panel: CancellationSectionPanel },
    { key: 'directDebit', label: 'Direct Debit', Panel: DirectDebitNoticeSectionPanel },
    { key: 'banners', label: 'Banners', Panel: BannersSectionPanel },
    { key: 'checkin', label: 'Check-in', Panel: CheckinSectionPanel },
    { key: 'membershipCard', label: 'Membership Card', Panel: MembershipCardSectionPanel },
    { key: 'facilityTypes', label: 'Facility Types', Panel: FacilityTypesPanel },
    { key: 'facilities', label: 'Facilities', Panel: FacilitiesPanel },
    { key: 'facilitySchedules', label: 'Facility Schedules', Panel: FacilitySchedulesSectionPanel },
    { key: 'posItemTypes', label: 'POS Item Types', Panel: PosItemTypesPanel },
    { key: 'memberCategories', label: 'Member Categories', Panel: MemberCategoriesPanel },
    // NB: shift checklists are no longer a settings section — they're club-owner-managed
    // from CRM > Shift Checklists (/members/shift-checklists).
    { key: 'metadata', label: 'Metadata', Panel: ClientMetadataPanel },
    { key: 'paymentProviders', label: 'Payment Providers' },
    { key: 'notifications', label: 'Notifications' },
    { key: 'integrations', label: 'Integrations' },
    { key: 'advanced', label: 'Advanced' },
];
